import React from 'react';
import { DataCard, OverviewHeader } from '@brighterion/br-ui';

import styles from './InfoOverview.css';

// TODO: This component is identical to the one in src/coponents/AddRulePage/AddRuleOverview. Refactor!

type Props = Omit<React.ComponentProps<typeof OverviewHeader>, 'children'> & {
    topData?: React.ComponentProps<typeof DataCard>[];
    bottomData?: React.ComponentProps<typeof DataCard>[];
    children?: React.ReactNode;
};

const InfoOverview = ({ leftTitle, rightTitle, topData, bottomData, dataTestId, children }: Props) => {
    return (
        <OverviewHeader
            dataTestId={dataTestId}
            leftTitle={leftTitle}
            rightTitle={rightTitle}
            containerClassName={styles.overviewHeader}
        >
            {children ? (
                <>{children}</>
            ) : (
                <div className={styles.overviewWrapper}>
                    <div className={styles.left}>
                        {topData?.map((o) => {
                            return (
                                <div className={styles.leftCard} key={o.label}>
                                    {o?.data}
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.left}>
                        {bottomData?.map((o) => {
                            return (
                                <div className={styles.leftCard} key={o.label}>
                                    {o?.data}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </OverviewHeader>
    );
};

export default InfoOverview;
